import Vue from 'vue'
import codeMask from '@/assets/js/codeMask'

Vue.filter('codeMask', (value, options) => {
  return codeMask(value, options)
})
